<template>
  <div style="">
    <div style="line-height: 35px;font-size: 14px;">应选课时：{{ksyq}} <span style="padding-left: 30px;"></span>已选课时：{{yxks}}
    </div>
    <el-table ref="multipleXsTable" :data="tableData" tooltip-effect="dark" style="width: 100%"
      @selection-change="handleSelectionChange" row-key="id" v-loading="loading" height="550">
      <el-table-column type="selection" width="55" :selectable="checkSelectable">
      </el-table-column>
      <el-table-column label="名称" show-overflow-tooltip>
        <template slot-scope="scope">{{ scope.row.cname }}</template>
      </el-table-column>
      <el-table-column prop="author" label="讲师" width="120">
      </el-table-column>
      <el-table-column prop="ks" label="课时" width="120">
      </el-table-column>
      <el-table-column prop="xstime" label="时长" width="120">
      </el-table-column>
      <el-table-column label="必修" v-if="productPxxz" width="120">
        <template slot-scope="scope">
          <el-tag v-if="scope.row[bixiu]==1">必修</el-tag>
          <el-tag v-else type="info">选修</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="description" label="简介" width="100">
      </el-table-column>
    </el-table>
  </div>
</template>


<script>
  import {
    getTimer,
    format
  } from '../../assets/js/common.js'
  export default {
    name: 'Muhistor',
    props: ['wjSrc', 'currId', 'ksyq', 'selectIds', 'productPxxz'],
    data() {
      return {
        tableData: [],
        loading: true,
        formInline: {
          currId: '',
          page: 1,
          rows: 30
        },
        productInfo: {
          ksyq: 0
        },
        bixiu: '',
        yxks: 0,
        total: 0
      }
    },
    methods: {
      getList: function(id) {
        this.loading = true;
        var formInline = this.formInline;
        formInline.currId = this.currId;
        this.$axios.get('/kt/wz/productInfo/getKcByCurrId.htm?' + this.$qs.stringify(formInline)).then(res => {
          var data = res.data;
          this.total = data.total;
          this.tableData = data.rows;
          if (this.productPxxz) {
            this.openMonted()
          } else {
            this.loading = false;
          }

        })
      },
      openMonted: function() {
        var _this = this;
        setTimeout(function() {
          _this.tableData.map((item, i) => {
            if (item[_this.bixiu] == 1) {
              _this.$refs.multipleXsTable.toggleRowSelection(item, true);
            }
          });
          _this.loading = false;
        }, 500)
      },
      handleSelectionChange: function(row) {
        var yxks = 0;
        var selectIds = [];
        row.map((item, i) => {
          yxks += Number(item.ks);
          selectIds.push(item.id);
        });
        this.yxks = yxks;
        this.$emit('changKc', selectIds, yxks);
      },
      changeParams: function(key, val) {
        this.$set(this.formInline, key, val);
      },
      handleSizeChange: function(size) {
        this.$set(this.formInline, 'rows', size);
        this.getList();
      },
      handleCurrentChange: function(page) {
        this.$set(this.formInline, 'page', page)
        this.getList();
      },
      checkSelectable(row) {
        if (this.bixiu) {
          return ((row.ks <= this.ksyq - this.yxks) || (this.selectIds.indexOf(row.id) >= 0)) && (row[this.bixiu] != 1);
        } else {
          return (row.ks <= this.ksyq - this.yxks) || (this.selectIds.indexOf(row.id) >= 0);
        }

      },
    },
    components: {},
    created: function() {
      // 主要负责人初次培训
      if (this.productPxxz == 1) {
        this.bixiu = 'pxxzFzrchu'
      };
      if (this.productPxxz == 2) {
        this.bixiu = 'pxxzFzrfu'
      }
      if (this.productPxxz == 3) {
        this.bixiu = 'pxxzGlchu'
      }
      if (this.productPxxz == 4) {
        this.bixiu = 'pxxzGlfu'
      }
      this.getList();
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/common/SelectXs.vue